var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRestaurant(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.25,
    height: 17.999,
    viewBox: "0 0 11.25 17.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-restaurant",
    "data-name": "Icon map-restaurant",
    d: "M11.7,1.069V5.22h-.75V1.095a.375.375,0,0,0-.75,0V5.22H9.45V1.081a.376.376,0,0,0-.75-.012V5.22H7.95V1.1a.375.375,0,0,0-.75-.02V6.505A1.415,1.415,0,0,0,8.7,7.8v9.791a1.125,1.125,0,1,0,2.25,0V7.8a1.5,1.5,0,0,0,1.5-1.21V1.081a.376.376,0,0,0-.75-.012Zm3.375,1.15v9.375h.75v6c0,1.5,2.625,1.5,2.625,0V2.22C18.45.345,15.075.345,15.075,2.22Z",
    transform: "translate(-7.2 -0.72)",
    fill: "#364436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRestaurant);
export default __webpack_public_path__ + "static/media/icon-restaurant.ec46af24cd191a220fffcdb54ce5142c.svg";
export { ForwardRef as ReactComponent };